import { useTranslations } from 'next-intl'
import { Checkbox } from '@/app/[locale]/(ui)/checkbox'

import { cn } from '@/lib/utils'
import { Link } from '@/i18n/navigation'

export const TermsAndConditions = ({
  className,
  checked,
  simple = false,
  onChange,
}: {
  className?: string
  checked: boolean
  simple?: boolean
  onChange: (checked: boolean) => void
}) => {
  const t = useTranslations()

  return (
    <label className={cn('flex select-none items-start', className)}>
      <Checkbox className="mt-1" checked={checked} onChange={onChange} />{' '}
      <p className="mt-1 text-sm">
        {simple ? t('Terms_and_conditions_message_simple') : t('Terms_and_conditions_accept_message')}
        <Link className="underline" href="/vilkar" target="_blank">
          {t('terms_and_conditions')}
        </Link>
        .
      </p>
    </label>
  )
}
